import { BaseService } from './base-service';
import { ActivityDTO, GetActivityOptionsParamsDTO } from '@/core/dto/activity';

class ActivityService extends BaseService<ActivityDTO> {
	constructor(public readonly basePath: string = '/activity') {
		super();
	}

	async listOptions(params: GetActivityOptionsParamsDTO): Promise<ActivityDTO[]> {
		const { data } = await this.getInstance().get<ActivityDTO[]>(this.basePath, { params });
		return data;
	}
}

const Service = Object.freeze(new ActivityService());
export { Service };
